import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import IdleVue from 'idle-vue';
import store from './store/';
import './registerServiceWorker';
import { googleApiKey } from './config';
import jQuery from 'jquery'
global.jQuery=jQuery
global.$=jQuery

Vue.config.productionTip = false;

import moment from 'moment';
moment.locale('id');

import * as VueGoogleMaps from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: googleApiKey,
		libraries: 'places',
	}
})

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 15 * 60 * 1000, // 10 seconds
  startAtIdle: false
});

import VueContentLoading from 'vue-content-loading'
Vue.component('vcl', VueContentLoading);

import NoData from '@/components/layout/vo/NoData';
Vue.component('NoData', NoData)

import LoadData from '@/components/layout/vo/LoadingData';
Vue.component('LoadData', LoadData)

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

import wysiwyg from "vue-wysiwyg"
Vue.use(wysiwyg, {hideModules: { "headings": true, "code": true, "image": true, "table": true, "removeFormat": true, "link": true, "separator": true, "justifyLeft": true, "justifyCenter": true, "justifyRight": true }})

import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, { 
	locale: 'pt-BR',
	decimalLength: 0,
	autoDecimalMode: false,
	min: null,
	max: 99999999999,
	defaultValue: null,
	valueAsInteger: false,
	allowNegative: false
})

new Vue({
	router,
	vuetify,
	store,
	render: h => h(App)
}).$mount('#app');

Vue.mixin({
	data: () => {
		return {
			today: moment(new Date()).format('YYYY-MM-DD'),
			search_text: '',
			limit: 1,
		}
	},
	methods: {
		convertDate(val) {
			if (Array.isArray(val)) {
				if (val.length > 0) {
					return val.map((el) => {
						return this.$options.filters.tanggal(el);
					})
				} else {
					return ''
				}
			} else {
				if (val) {
					return this.$options.filters.tanggal(val);
				} else {
					return ''
				}
			}
		},
		convertMonth(val) {
			if (Array.isArray(val)) {
				if (val.length > 0) {
					return val.map((el) => {
						return this.$options.filters.bulantahun(el);
					})
				} else {
					return ''
				}
			} else {
				if (val) {
					return this.$options.filters.bulantahun(val);
				} else {
					return ''
				}
			}
		},
		queryString(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},
		onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
				$event.preventDefault();
			}
		},
	},
	created() {
		if (this.$route) {
			if (this.$route.name == 'search-product') {
				if (this.$route.query.search) {
					this.search_text = this.$route.query.search.replace(/-/g, ' ')
				}
			}
		}
	},
	watch: {
		
	}
})

Vue.filter('hari', function(value) {
	var date = moment(value).format('dddd')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('toTanggal', function(value) {
	var date = moment(value).format('DD')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tanggal', function(value) {
	var date = moment(value).format('DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('formatTgl', function(value, format) {
	var date = moment(value).format(format)
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('bulan', function(value) {
	var date = moment(value).format('MMMM')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tahun', function(value) {
	var date = moment(value).format('YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('bulantahun', function(value) {
	var date = moment(value).format('MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('haritanggal', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('jam', function(value) {
	var date = moment(value).format('HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tanggaljam', function(value) {
	var date = moment(value).format('DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('haritanggaljam', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('toNumber', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	if (Number.isNaN(parseInt(value))) {
		return 0
	} else {
		return formatter.format(parseInt(value));
	}
});

Vue.filter('emptyData', function(value) {
	if (value === null || value === undefined || value === '') {
		return '-'
	} else {
		return value
	}
});

Vue.filter('longText', function(value, maxlenght) {
	if (value === null || value === undefined || value === '') {
		return '-'
	} else {
		if (value.length > maxlenght) {
			const viewText = `<span title="${value.toUpperCase()}">${value.substr(0, maxlenght) + '...'}</span>`
			return viewText
		} else {
			return value
		}
	}
});

Vue.filter('ellipsisText', function(value, maxlenght) {
	if (value === null || value === undefined || value === '') {
		return '-'
	} else {
		if (value.length > maxlenght) {
			return value.substr(0, maxlenght) + '...'
		} else {
			return value
		}
	}
});

Vue.filter('toRupiah', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	if (Number.isNaN(parseInt(value))) {
		return `Rp 0`
	} else {
		return `Rp ${formatter.format(parseInt(value))}`;
	}
});

Vue.filter('toKg', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});
	if( parseInt(value) >= 1000 ){
		return formatter.format(parseInt(value)/1000) + ' kg';
	} else {
		return formatter.format(parseInt(value)) + ' gr';
	}
});

Vue.filter('two_digits', (value) => {
	if (value < 0) {
		return '00';
	}
	if (value.toString().length <= 1) {
		return `0${value}`;
	}
	return value;
});

Vue.filter('toStatusMidtrans', (value) => {
	const status = {
		'capture': 'Lunas',
		'settlement': 'Lunas',
		'pending': 'Belum Dibayar',
		'cancel': 'Dibatalkan',
		'rejected': 'Ditolak Admin',
		'expired': 'Kedaluwarsa'
	}
	return status[value];
});

Vue.filter('toIconTransaction', (value) => {
	const status = {
		'created': 'mdi-wallet-outline',
		'expired': 'mdi-timer-off-outline',
		'cancel': 'mdi-alert-circle-outline',
		'paid': 'mdi-archive-arrow-up-outline',
		'processed': 'mdi-package-variant',
		'on_delivery': 'mdi-truck-delivery-outline',
		'completed': 'mdi-check-circle-outline',
		'rejected_admin': 'mdi-alert-circle-outline',
		'rejected_seller': 'mdi-alert-circle-outline'
	}
	return status[value];
});

Vue.filter('toNoteStock', value => {
	let note = 'Stok tersedia.'
	if (value <= 0) {
		note = 'Stok habis.'
	} else if (value <= 10) {
		note = 'Stok tinggal <10, beli segera!'
	} else if (value <= 20) {
		note = 'Stok tinggal <20, beli segera!'
	}
	return note
})
